if (typeof boostPFSThemeConfig !== 'undefined') {
	// Override Settings
	var boostPFSFilterConfig = {
		general: {
			limit: boostPFSConfig.custom.products_per_page,
			loadProductFirst: true,
			numberFilterTree: 2,
			selectOptionContainer: '.grid__item .card-wrapper',
			stickyFixTopPos: true
		},
		selector: {
			otpTopCartCount: '.cart-count-bubble'
		}
	};
}
// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;

(function () {
	var onSale = false,
		soldOut = false,
		priceVaries = false,
		images = [],
		boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066];


	BoostPFS.inject(this);

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function (e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}

	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function (data) {
		if (!data) data = this.data;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Add Custom class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		var saleClass = onSale ? boostPFSTemplate.saleClass : '';

		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

		itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

		// Add Card product class
		itemHtml = itemHtml.replace(/{{cardProductClass}}/g, buildCardProductClass());
		// Add sold out Label
		itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());
		// Add sale Label
		itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel());
		// Add Images
		//itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
      	// Add Cusom Images itemImage
      	itemHtml = itemHtml.replace(/{{itemImage}}/g, customImage(data));
		// Add Price
		//itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));

		// Add Review
		if (typeof Integration === 'undefined' ||
			(typeof Integration != 'undefined' &&
				typeof Integration.hascompileTemplate == 'function' &&
				!Integration.hascompileTemplate('reviews'))) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
		}

		// Add Vendor
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
      	// Add Wishlist
      	var wishlistHtml = '<div class="product-wishlist-area">' +
                              '<button data-with-epi="true" class="swym-b utton swym-add-to-wishlist-view-product product_'+ data.id + '" data-swaction="addToWishlist" data-product-id="'+ data.id + '" data-variant-id="' + data.variants[0].id + '" data-product-url="'+ Utils.buildProductItemUrl(data) +'"></button>' +
                            '</div>';
        itemHtml = itemHtml.replace(/{{itemWishlist}}/g, wishlistHtml);
      	// Add Custom Price
      	itemHtml = itemHtml.replace(/{{itemNewPrice}}/g, customPrice(data));
      	// Add Meta excerpt
      	itemHtml = itemHtml.replace(/{{itemMetaExcerpt}}/g, Utils.getProductMetafield(data, 'my_fields', 'excerpt'));
		// Add Reviews
		var reviewsHtml = '<div class="klaviyo-star-rating-widget" data-id="' + data.id + '" data-product-title="' + data.title + '" data-product-type="' + data.product_type + '" data-product-vendor="' + data.vendor + '" data-product-url="' + Utils.buildProductItemUrl(data) + '"><div aria-label="5 stars, 5 ratings" class="kl_reviews__star_rating_widget"></div></div>';
		itemHtml = itemHtml.replace(/{{itemReviews}}/g, reviewsHtml);
   
      	


	// Add Vendor
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
      	// Add Wishlist
      	var wishlistHtml = '<div class="product-wishlist-area">' +
                              '<button data-with-epi="true" class="swym-button swym-add-to-wishlist-view-product product_'+ data.id + '" data-swaction="addToWishlist" data-product-id="'+ data.id + '" data-variant-id="' + data.variants[0].id + '" data-product-url="'+ Utils.buildProductItemUrl(data) +'"></button>' +
                            '</div>';
        itemHtml = itemHtml.replace(/{{itemWishlist}}/g, wishlistHtml);
      	// Add Custom Price
      	itemHtml = itemHtml.replace(/{{itemNewPrice}}/g, customPrice(data));
      	// Add Meta excerpt
      	itemHtml = itemHtml.replace(/{{itemMetaExcerpt}}/g, Utils.getProductMetafield(data, 'my_fields', 'excerpt'));
      	// Add Reviews
		var reviewsHtml = '<div class="klaviyo-star-rating-widget" data-id="' + data.id + '" data-product-title="' + data.title + '" data-product-type="' + data.product_type + '" data-product-vendor="' + data.vendor + '" data-product-url="' + Utils.buildProductItemUrl(data) + '"><div aria-label="5 stars, 5 ratings" class="kl_reviews__star_rating_widget"></div></div>';
		itemHtml = itemHtml.replace(/{{itemReviews}}/g, reviewsHtml);
		// Add Subtitle metafield (custom_fields.subtitle)
		itemHtml = itemHtml.replace(
		/{{itemMetaSubtitle}}/g,
		Utils.getProductMetafield(data, 'custom_fields', 'subtitle') || ''
		);

		// Add Includes text metafield (custom_fields.includes_text)
		itemHtml = itemHtml.replace(
		/{{itemMetaIncludes}}/g,
		Utils.getProductMetafield(data, 'custom_fields', 'includes_text') || ''
		);

		// Add badges based on product tags (15/20/25 off + bestseller)
		itemHtml = itemHtml.replace(/{{itemBadges}}/g, buildBadges(data));

		// HA changes for restricting cart page redirection in the collection page
		itemHtml = itemHtml.replace(/{{itemFirstVariantId}}/g, firstVariant.id);

		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
		return itemHtml;
	};

	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
	function buildImages(data) {
		var html = '',
			aspectRatio = '',
			rangeWidths = boostPFSRangeWidths,
			paddingBottom = 100;

		var dataSrcSet = '',
			imgAlt = data.title,
			flipImageSrcSet = '';

		var activeSwapImage = !Utils.isMobile() && images.length > 1 &&
			boostPFSThemeConfig.custom.hasOwnProperty('show_secondary_image') &&
			boostPFSThemeConfig.custom.show_secondary_image == true;

		for (var i = 0; i < rangeWidths.length; i++) {
			dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';

			if (activeSwapImage) {
				flipImageSrcSet += Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
			}

			if (i < rangeWidths.length - 1) {
				dataSrcSet += ', ';

				if (activeSwapImage) {
					flipImageSrcSet += ', ';
				}
			}
		}

		if (images.length > 0) {
			aspectRatio = images[0]['width'] / images[0]['height'];
			paddingBottom = 1 / aspectRatio * 100;

			html += '<div';
			if (boostPFSThemeConfig.custom.hasOwnProperty('add_image_padding') &&
				boostPFSThemeConfig.custom.add_image_padding === true) {
				html += ' class="card__media-full-spacer"';
			}
			html += '>';
			html += '<div class="media media--transparent media--';
			if (boostPFSThemeConfig.custom.hasOwnProperty('media_size')) {
				html += boostPFSThemeConfig.custom.media_size;
			}
			html += ' media--hover-effect"';
			if (boostPFSThemeConfig.custom.hasOwnProperty('media_size') &&
				boostPFSThemeConfig.custom.media_size == 'adapt' &&
				images.length > 0) {
				html += ' style="padding-bottom: ' + paddingBottom + '%"';
			}
			html += '>'
			html += '<img class="motion-reduce"' +
				'loading="lazy"' +
				'srcset="' + dataSrcSet + '" ' +
				'height="' + images[0].height + '" ' +
				'width="' + images[0].width + '" ' +
				'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
				'src="' + Utils.optimizeImage(images[0].src, '533x') + '" ' +
				'alt="' + imgAlt + '" />';

			if (activeSwapImage) {
				html += '<img class="motion-reduce"' +
				'loading="lazy"' +
				'srcset="' + flipImageSrcSet + '" ' +
				'height="' + images[1].height + '" ' +
				'width="' + images[1].width + '" ' +
				'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
				'src="' + Utils.optimizeImage(images[1].src, '533x') + '" ' +
				'alt="' + imgAlt + '" />';
			}
			html += '</div>';
			html += '</div>';
		} else {
			html += '<div class="card__content"><h2 class="card__text h2">' + data.title  + '</h2></div>'
		}
		return html;
	}

	function buildCardProductClass() {
		var html = '';
		if (!images || (images && images.length === 0)) {
			html = 'card--text-only card--soft';
		} else if(boostPFSThemeConfig.custom.hasOwnProperty('show_image_outline') && boostPFSThemeConfig.custom.show_image_outline) {
      html = 'card--outline';
    }
		return html;
	}

	function buildVendor(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
			boostPFSThemeConfig.custom.show_vendor === true) {
			html = boostPFSTemplate.vendorHtml;
		}
		return html;
	}

	function buildPrice(data) {
		var html = '';
		var noComparePrice = data.price_varies === false && data.compare_at_price_varies;
		var moneyPrice = priceVaries ? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, Utils.formatMoney(data.price_min))
			: Utils.formatMoney(data.price_min);
		var unitPriceClass = !data.available || typeof data?.selected_or_first_available_variant?.unit_price_measurement === 'undefined' ? 'hidden' : ''
		html = `<div class="price ${soldOut ? 'price--sold-out' : ''} ${onSale ? 'price--on-sale' : ''}${noComparePrice ? 'price--no-compare' : ''}"
					<dl>
						<div class="price__regular">
							<dt>
								<span class="visually-hidden visually-hidden--inline">
									${boostPFSConfig.label.regular_price}
								</span>
							</dt>
							<dd>
								<span class="price-item price-item--regular">
									${moneyPrice}
						  		</span>
							</dd>
						</div>
						<div class="price__sale">
							<dt class="price__compare">
								<span class="visually-hidden visually-hidden--inline">
									${Utils.formatMoney(data.sale_price)}
								</span>
							</dt>
							<dd class="price__compare">
								<s class="price-item price-item--regular">
								${Utils.formatMoney(data.compare_at_price_min)}
								</s>
						  	</dd>
							<dt>
							  <span class="visually-hidden visually-hidden--inline">${boostPFSConfig.label.sale_price}</span>
							</dt>
							<dd class="price__last">
								<span class="price-item price-item--sale">
									${moneyPrice}
								</span>
						  	</dd>
						</div>
						<small class="unit-price caption ${unitPriceClass}">
							<dt class="visually-hidden">${boostPFSConfig.label.unit_price}</dt>
							<dd class="price__last">
								<span>${Utils.formatMoney(data.selected_or_first_available_variant && data.selected_or_first_available_variant.unit_price)}</span>
								<span aria-hidden="true">/</span>
								<span class="visually-hidden">&nbsp;${boostPFSConfig.label.unit_price_separator}&nbsp;</span>
							</dd>
					  </small>
					</dl>
				</div>`
		return html;
	}

	function buildSoldOutLabel() {
		// Build Sold out label
		var soldOutLabel = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('sold_out_badge_color_scheme') && soldOut) {
			soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{soldOutBadgeClass}}/g, boostPFSThemeConfig.custom.sold_out_badge_color_scheme);
		}
		return soldOutLabel;
	}

	function buildSaleLabel() {
		// Build Sale label
		var saleLabel = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('sale_badge_color_scheme') && onSale && !soldOut) {
			saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{saleBadgeClass}}/g, boostPFSThemeConfig.custom.sale_badge_color_scheme);
		}
		return saleLabel;
	}

	function buildReview(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
			boostPFSThemeConfig.custom.show_product_review == true && Utils.getProductMetafield(data, 'reviews', 'rating') !== null) {
			var ratingObj = JSON.parse(Utils.getProductMetafield(data, 'reviews', 'rating'));
      var rating_decimal = 0;
      var decimal = parseFloat(ratingObj.value.rating);
      if (decimal >=0.3 && decimal <= 0.7) {
        rating_decimal = 0.5;
      } else if (decimal > 0.7) {
        rating_decimal = 1;
      }
      html = `<div class="rating" role="img" aria-label="${boostPFSConfig.label.star_reviews_info.replace('{{ rating_value }}', ratingObj.value).replace('{{ rating_max }}', ratingObj.value.scale_max)}">
                <span aria-hidden="true" class="rating-star color-icon-${boostPFSConfig.custom.accent_icons}" style="--rating: ${Math.round(ratingObj.value.rating)}; --rating-max: ${ratingObj.value.scale_max}; --rating-decimal: ${rating_decimal};"></span>
              </div>
              <p class="rating-text caption">
                <span aria-hidden="true">${ratingObj.value} / ${ratingObj.value.scale_max}</span>
              </p>
              <p class="rating-count caption">
                <span aria-hidden="true">(${Utils.getProductMetafield(data, 'reviews', 'rating_count')})</span>
                <span class="visually-hidden">${Utils.getProductMetafield(data, 'reviews', 'rating_count')} ${boostPFSConfig.label.total_reviews}</span>
              </p>`;
		}
		return html;
	}

	function buildBadges(data) {
  var html = '';
  var tags = data.tags || [];

  // In case tags comes as a comma-separated string
  if (Object.prototype.toString.call(tags) === '[object String]') {
    tags = tags.split(',').map(function(t) { return t.trim(); });
  }

  function hasTag(tag) {
    return tags.indexOf(tag) !== -1;
  }

  // % OFF badges
  if (hasTag('15-off')) {
    html += '<div class="sale-badge"><span class="sale-number">15%</span> <span class="sale-text">OFF</span></div>';
  }
  if (hasTag('20-off')) {
    html += '<div class="sale-badge"><span class="sale-number">20%</span> <span class="sale-text">OFF</span></div>';
  }
  if (hasTag('25-off')) {
    html += '<div class="sale-badge"><span class="sale-number">25%</span> <span class="sale-text">OFF</span></div>';
  }

  // Best Seller badge
  if (hasTag('bestseller')) {
    html += '<div class="best-seller-badge">Best Seller</div>';
  }

  return html;
}








function customImage(data) {
  var html = '',
      images = data.images_info,
      imgAlt = data.title,
      desktopSize = '400x',
      tabletSize = '834x',
      mobileSize = '480x';

  if (!images || images.length === 0) {
    return '<div class="card__content"><h2 class="card__text h2">' + data.title + '</h2></div>';
  }

  function src(img, size) {
    return Utils.optimizeImage(img.src, size);
  }

  function srcSet(img) {
    return src(img, mobileSize) + ' 320w, ' +
           src(img, tabletSize) + ' 768w, ' +
           src(img, desktopSize) + ' 1200w';
  }

  var main = images[0];

  html += '<div class="picture-element-wrapper object-fit--contain">';
  html += '<picture>';
  html += '<img class="picture-element-image" '
      + 'src="' + src(main, desktopSize) + '" '
      + 'srcset="' + srcSet(main) + '" '
      + 'alt="' + imgAlt + '" draggable="false" loading="lazy">';
  html += '</picture>';
  html += '</div>';

  return html;
}





  
  
  function customPrice(data) {
  var html = '';
  html += '<div class="product-title-price-flex">' +
            '<span class="product-title">' + data.title + '</span>' +
            '<div class="flex f-a-center f-j-between f-wrap price__container">' +
              '<p class="product-prices flex f-a-center">';

  if (!onSale) {
    html += '<span class="compare-at-price hide">';
  } else {
    html += '<span class="compare-at-price">';
  }

  html += '<span class="money">' + Utils.formatMoney(data.compare_at_price_min) + '</span>' +
          '</span>';

  if (onSale) {
    html += '<span class="money product-price on-sale">';
  } else {
    html += '<span class="money product-price">';
  }

  html += Utils.formatMoney(data.price_min);
  html += '</span>' +
            '<div class="reviews">' +
              '<div class="klaviyo-star-rating-widget" ' +
                   'data-id="' + data.id + '" ' +
                   'data-product-title="' + data.title + '" ' +
                   'data-product-type="' + data.product_type + '">' +
              '</div>' +
            '</div>' +
          '</p>' +
        '</div>' +
      '</div>';

  return html;
}

	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;
		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				var paramSort = Globals.queryParams.sort || '';
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					var isSelected = ''
					if(paramSort == k) {
						isSelected = 'selected="selected"'
					}
					sortingItemsHtml += '<option value="' + k + '"' + isSelected + '>' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	ProductSorting.prototype.render = function () {
		jQ(Selector.topSorting).html(this.compileTemplate());

		if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
			jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
		}

		var labelSort = '';
		var paramSort = Globals.queryParams.sort || '';
		var sortingList = Utils.getSortingList();
		if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
			labelSort = sortingList[paramSort];
		} else {
			labelSort = Labels.sorting;
		}

		jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
	}

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function() {
		jQ(Selector.topSorting + ' .facet-filters__sort').change(function(e) {
			e.preventDefault();
			FilterApi.setParam('sort', jQ(this).val());
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
		});
	};

  // Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;
	}

	// Build Additional Elements
	Filter.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		jQ('.boost-pfs-filter-total-product').html(data.total_product + ' products');
	};

	/************************** END BUILD TOOLBAR **************************/
})();











// HA changes for restricting cart page redirection
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.boost-atc-btn');
  if (!btn) return;

  const variantId = btn.getAttribute('data-variant-id');
  if (!variantId) return;

  e.preventDefault();

  const textEl = btn.querySelector('.HA-atc-tick-mark');
  const spinner = btn.querySelector('.loading-overlay__spinner');

  // Start loading
  btn.classList.add('loading');
  if (spinner) spinner.classList.remove('hidden');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(res => res.json())
    .then(() => {
      // Show tick mark
      if (textEl) {
        textEl.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16" aria-hidden="true">
            <path fill="currentColor" d="M6.173 12.414L2.11 8.35l1.414-1.414 2.65 2.65 6.3-6.3 1.414 1.414z"/>
          </svg>
        `;
        btn.classList.add('added');
      }

      // Update Cart Bubble
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          const bubble = document.querySelector('.cart-count-bubble');
          if (bubble) bubble.textContent = cart.item_count;
        });
		
    })
    .finally(() => {
      btn.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
    });
});
